import PropTypes from 'prop-types';
import { createRef, PureComponent } from 'react';
import FieldSuggestions from './FieldSuggestions.component';

import { fetchQuery } from 'Util/Request';

export class FieldSuggestionsContainer extends PureComponent {
    state = {
        suggestions: [],
        isExpanded: false,
        lastValue: null
    }

    containerProps() {
        const {
            suggestions,
            isExpanded
        } = this.state;

        const {
            attr,
            events,
            setRef,
            isDisabled,
            suggestionsConfig: {
                isEnabled
            }
        } = this.props;

        return {
            suggestions,
            isExpanded,
            attr,
            events: {
                ...events,
                onChange: this.onChangeProxy.bind(this),
                onFocus: this.onFocus.bind(this)
            },
            setRef,
            isDisabled,
            isSuggestionsEnabled: isEnabled
        };
    }

    fieldRef = createRef();

    getSuggestionsDebounce = null;

    onChangeProxy(event) {
        this.props.events.onChange(event);
        if (this.props.suggestionsConfig.isEnabled) {
            const {
                suggestionsMinLength = 2
            } = this.props;
    
            const inputValue = event.target.value;
            this.setState({
                lastValue: event.target.value,
                suggestions: [],
                isExpanded: false
            });
            clearTimeout(this.getSuggestionsDebounce);
            if (inputValue.length >= suggestionsMinLength) {
                this.getSuggestionsDebounce = setTimeout(() => this.getSuggestions(inputValue), 300);
            }
        }
    }

    onFocus(event) {
        if (this.state.suggestions.length > 0) {
            this.setState({
                isExpanded: true
            });
        }
    }

    setRef(elem) {
        const { setRef } = this.props;

        setRef(elem);

        if (elem && this.fieldRef !== elem) {
            this.fieldRef = elem;
        }
    }

    containerFunctions = {
        // getSuggestions: this.getSuggestions.bind(this),
        handleSelectListOptionClick: this.handleSelectListOptionClick.bind(this),
        handleDropdownExpand: this.handleDropdownExpand.bind(this),
        setRef: this.setRef.bind(this),
    }

    async getSuggestions(inputValue) {
        const {
            suggestionsConfig: {
                suggestionsQuery,
                suggestionsDataKey,
                suggestionsOptionLabel
            }
        } = this.props;

        const { [suggestionsDataKey]: responseSuggestions } = await fetchQuery(suggestionsQuery(inputValue));

        if (this.state.lastValue === inputValue) {
            console.log(responseSuggestions);
            const suggestionOptions = responseSuggestions.map(rs => ({
                id: typeof suggestionsOptionLabel === 'function' ? suggestionsOptionLabel(rs).replaceAll(' ', '_') : rs,
                label: typeof suggestionsOptionLabel === 'function' ? suggestionsOptionLabel(rs) : rs,
                value: rs
            }));
            this.setState({
                suggestions: suggestionOptions,
                isExpanded: true
            });
        }
    }

    handleSelectListOptionClick(option) {
        const {
            changeValueOnDoubleClick,
            events: { onChange } = {},
            suggestionsConfig: {
                suggestionsOptionValueKey,
                suggestionsOptionLinkedValueRef,
                suggestionsOptionLinkedValueKey
            }
        } = this.props;
        const {
            value,
            target: {
                value: targetValue
            } = {}
        } = option;

        const orgFieldValue = value || targetValue || ''
        const fieldValue = suggestionsOptionValueKey ? orgFieldValue[suggestionsOptionValueKey] : orgFieldValue;

        if (changeValueOnDoubleClick) {
            this.fieldRef.value = this.fieldRef.value === value ? '' : fieldValue;
        } else {
            this.fieldRef.value = fieldValue;
        }

        this.fieldRef.focus();

        this.setState({
            suggestions: [],
            isExpanded: false
        });

        if (suggestionsOptionLinkedValueKey && suggestionsOptionLinkedValueRef) {
            suggestionsOptionLinkedValueRef.current.value = orgFieldValue[suggestionsOptionLinkedValueKey];
        }

        if (onChange) {
            onChange({ target: { value: fieldValue } });
        }
    }

    handleDropdownExpand() {
        this.setState({
            isExpanded: false
        });
    }

    render() {
        return (
            <FieldSuggestions
              { ...this.containerProps() }
              { ...this.containerFunctions }
            />
        )
    }
}

export default FieldSuggestionsContainer;